import axios from 'axios';
import { Component } from "react";
import PropTypes from 'prop-types';
import { globals } from '../Globals/Globals';

class ChatBotSubmit extends Component {
  constructor(props) {
    super(props);

    this.submit_state = {pending:-1, failed:1, success:0}

    this.state = {
      name: '',
      target: '',
      category: '',
      email: '',
      subject:'',
      err:this.submit_state.pending
    };
  }

  componentWillMount() {
    console.log("ChatbotSubit::componentWillMount");
    const { steps } = this.props;
    let { name, target, category, email, target_message, subject } = steps;
    email = this.props.email;

    this.setState({ name, target, category, email, target_message, subject });
  }

  componentDidMount = () => {
    console.log("ChatbotSubit::componentDidMount");
    this.onSubmitProcess();
  }

  toastError = error_message => {
    this.setState({message:error_message, err:this.submit_state.failed})
    if (this.props.onFailed) this.props.onFailed(error_message);
  }

  toastMessage = message => {
    this.setState({message:message, err:this.submit_state.success})
    if (this.props.onSuccess) this.props.onSuccess(message);
  }

  /***
   * Prototype : sendRequestGUIDToUserByMail
   */
  sendRequestGUIDToUserByMail = async (p_s_message) => {
    try{
        if (globals.parameters.debugging)
          console.log("sendRequestGUIDToUserByMail::state on acknowledge:", this.state)

        let regexpUUID =  /^(.*?)-/g;
        let match = regexpUUID.exec(this.state.dossier.uuidrequetes_log);

        if (match) {
            //Compute short_uuid
            //state disabled this.setState({short_uuid:match[1]});
            let l_short_uuid = match[1]

            //Post confirmation e-mail back to user
            const mailResult = await axios.post('https://mailer.jesusestlareponsepourtous.org/sendconfirmation',
                {
                    from:"ne-pas-repondre@jesusestlareponsepourtous.org",
                    email:this.state.email,
                    subject:"Accusé de réception de votre demande de prière",
                    //prenom:this.state.name.value,
                    prenom:"",
                    nom:"",//this.state.name.value,
                    //dossier:this.state.short_uuid,
                    dossier:l_short_uuid,
                    jour:this.state.dossier.jour.toString().padStart(2, '0'),
                    mois:this.state.dossier.mois.toString().padStart(2, '0'),
                    annee:this.state.dossier.annee,
                    heure:this.state.dossier.heure,
                    minutes:this.state.dossier.minutes.toString().padStart(2, '0'),
                    user_lounge_url:`https://jlrpt.com?uuid=${this.state.dossier.uuidrequetes_log}&user_mail=${this.state.email}`//Not used - PMAB on 2023-08-16
                }
            );

            if (globals.parameters.debugging)
              console.log("mailResult ->", mailResult)

            if (!mailResult) throw("Echec de l'envoi de la confirmation par courriel !")

            //Display confirmation number
            //this.toastMessage(`Un courriel de confirmation vous a été envoyé sous la référence: \r\n(${this.state.short_uuid})`)
            this.toastMessage(`Un courriel de confirmation vous a été envoyé sous la référence: \r\n(${l_short_uuid})`)

            //Clear form
            if(this.props.onSuccess) this.props.onSuccess();
        }
        else{
            this.toastError("Erreur:" + p_s_message);
        }
    } catch(err){
        this.toastError(`sendRequestGUIDToUserByMail :: Une erreur est survenue :${err}`);
        return;
    }
  }

  /***
   * Prototype : onSubmitProcess
   */
  onSubmitProcess  = async event => {
    this.setState({err:this.submit_state.pending, message:""})

    //call requete-service
    var serviceResult = null
    try{
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        //Get relevant properties
        if (globals.parameters.debugging)
          console.log("ChatBotSumbmit::state:", this.state)

        let requeteData = {
          nom : "",//this.state.name.value,
          prenom :"",
          email: this.state.email,
          //sujet: `${this.state.category.message} (créée avec l'assistant ChatBot)`,
          sujet: this.state.subject.message,
          //beneficiaire: (this.state.target_message.value == "other")?this.state.target.value:this.state.name.value,
          beneficiaire: this.state.target.value,
          idrubriques: this.state.category.value,
          country_code: "FR" //74
        }

        if (globals.parameters.debugging)
          console.log("requeteData:", requeteData)
        
        serviceResult = await axios.post(globals.req_add_proc_endpoint.url,requeteData);
    } catch(err){
        this.toastError(`Verifiez votre connexion wifi : ${err}`);
        return;
    }

    //Get service aknowledge before resetting state values.
    if (globals.parameters.debugging){
      console.log("serviceResult ==>", serviceResult)
      console.log("serviceResult.data.items[0] ==>", serviceResult.data.items[0])
    }

    if (serviceResult.data.state != true){
        this.toastError("Erreur:" + serviceResult.data.message);
    }
    else{
      //Set new dossier porperty in state object
      this.setState({dossier:serviceResult.data.items[0]}, ()=>{
        if (globals.parameters.debugging) console.log(":SynChronous this.state =>", this.state); 
        this.sendRequestGUIDToUserByMail(serviceResult.data.message)});
    }
}  


  render() {
    const { name, target, category, email } = this.state;
    return (
      <div>
        <div>
          {(this.state.err == this.submit_state.pending) && <h5 style={{color:'orange'}}>Soumission...</h5>}
          {(this.state.err == this.submit_state.failed) && <h5 style={{color:'red'}}>Echec de soumission</h5>}
          {(this.state.err == this.submit_state.success) && <h5 style={{color:`blue`}}>Soumission réussie</h5>}
          {this.state.message}
        </div>
      </div>
    );
  }
}

export default ChatBotSubmit;